import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useSocket } from "../contexts/SocketContext";

const NotificationBar = () => {
    const socket = useSocket();

    const [showNotificationBar, setShowNotificationBar] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");

    // Listen for notification events
    useEffect(() => {
        if (!socket) return;

        const handleNotificationMessage = (data) => {
            console.log("📢 New Notification:", data);
            setNotificationMessage(data?.message);
            setShowNotificationBar(true);

            // Auto-close after 3s
            const timer = setTimeout(() => {
                setShowNotificationBar(false);
            }, 3000);

            return () => clearTimeout(timer);
        };

        // When a new notification is received
        socket.on("noob_notification", handleNotificationMessage);

        return () => {
            socket.off("noob_notification", handleNotificationMessage);
        };
    }, [socket]);

    return (
        <AnimatePresence>
            {showNotificationBar && (
                <motion.div
                    initial={{ opacity: 0, scaleX: 0, x: "-50%" }}
                    animate={{ opacity: 1, scaleX: 1, x: "-50%" }}
                    exit={{ opacity: 0, scaleX: 0, x: "-50%" }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="fixed top-2 left-1/2 z-60 bg-background/90 backdrop-blur-lg shadow-lg px-6 py-3 rounded-2xl border border-primary/30 flex items-center space-x-3"
                    style={{ transformOrigin: "center", width: "98%" }}
                >
                    <div className="flex-1 text-center">
                        <p className="text-primary font-medium">{notificationMessage}</p>
                    </div>
                    <button
                        onClick={() => setShowNotificationBar(false)}
                        className="text-primary hover:text-primary/70"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default NotificationBar;
